import {
  SESSION_STORAGE_SCANBAT_COMPANY,
  SESSION_STORAGE_SCANBAT_WAREHOUSE,
} from '@/common/constants';

const SessionStorageScanbat = (() => {
  let service;

  function getService() {
    if (!service) {
      service = this;

      return service;
    }

    return service;
  }

  function getScanbatCompany() {
    return sessionStorage.getItem(SESSION_STORAGE_SCANBAT_COMPANY);
  }

  function getScanbatWarehouse() {
    return sessionStorage.getItem(SESSION_STORAGE_SCANBAT_WAREHOUSE);
  }

  function setScanbatCompany(company) {
    sessionStorage.setItem(SESSION_STORAGE_SCANBAT_COMPANY, company);
  }

  function setScanbatWarehouse(warehouse) {
    sessionStorage.setItem(SESSION_STORAGE_SCANBAT_WAREHOUSE, warehouse);
  }

  function clearScanBat() {
    sessionStorage.removeItem(SESSION_STORAGE_SCANBAT_COMPANY);
    sessionStorage.removeItem(SESSION_STORAGE_SCANBAT_WAREHOUSE);
  }

  return {
    clearScanBat,
    getScanbatCompany,
    getScanbatWarehouse,
    getService,
    setScanbatCompany,
    setScanbatWarehouse,
  };
})();

export default SessionStorageScanbat;
